import { IToken } from 'interfaces/token';
import Storage from 'utils/storage';
export const LOGIN_URL = '/login';

export const setToken = (data: IToken): void => {
	const rememberMe = Storage.getItem('rememberMe');
	if (rememberMe) {
		Storage.setItem('token', data);
	} else {
		sessionStorage.setItem('token', JSON.stringify(data));
	}
};

export const getToken = (): IToken =>
	Storage.getItem('token') || JSON.parse(sessionStorage.getItem('token') || 'null');

export const removeToken = (): void => {
	const rememberMe = Storage.getItem('rememberMe');
	if (rememberMe) {
		Storage.removeItem('token');
	} else {
		sessionStorage.removeItem('token');
	}
};

export const removeTokenWithRedirect = (): void => {
	removeToken();
	if (window.location.pathname !== LOGIN_URL) {
		window.location.href = LOGIN_URL;
	}
};
